import { render, staticRenderFns } from "./skeletonLand.vue?vue&type=template&id=59d29d95&scoped=true&"
import script from "./skeletonLand.vue?vue&type=script&lang=js&"
export * from "./skeletonLand.vue?vue&type=script&lang=js&"
import style0 from "./skeletonLand.vue?vue&type=style&index=0&id=59d29d95&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d29d95",
  null
  
)

export default component.exports